import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionPartyMembersSubmitted2 = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = getFirstName(get(user, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      date={transition.createdAt}
      direction="left"
      buttons={buttons}
      header={
        isOwnTransition ? (
          <FormattedMessage id="BookingStatus.transitionAccept" values={{ displayName }} />
        ) : (
          <FormattedMessage id="BookingStatus.ownTransitionAccept" values={{ displayName }} />
        )
      }
    >
      {isOwnTransition ? (
        <FormattedMessage id="BookingStatus.transitionAcceptSubtext" />
      ) : (
        <FormattedMessage id="BookingStatus.ownTransitionAcceptSubtext" values={{ displayName }} />
      )}
    </InboxTransitionBase>
  );
};

export default InboxTransitionPartyMembersSubmitted2;
